/**
 * The one short-date format: "2026-08-24" -> "24 Aug" / "24 ส.ค.".
 *
 * Lifted out of SpendConversionTrend, which still imports it, because the
 * Dashboard's "?" popovers date their figures with the same string the trend
 * axis labels its days with. Two copies would be two conventions for one date.
 *
 * @module utils/shortDate
 */
import type { TFn } from '@/utils/channelCorrelation';

/**
 * Sliced, not Date-parsed, to avoid a timezone shift — the axis must not slide
 * a day because the browser is west of Bangkok. The month names are keys rather
 * than a literal array because this runs at module scope, where a translated
 * array would freeze at import.
 */
const MONTH_KEYS = [
  'common.monthJan', 'common.monthFeb', 'common.monthMar', 'common.monthApr',
  'common.monthMay', 'common.monthJun', 'common.monthJul', 'common.monthAug',
  'common.monthSep', 'common.monthOct', 'common.monthNov', 'common.monthDec',
] as const;

export const shortDate = (iso: string, t: TFn): string => {
  const [, m, d] = iso.split('-');
  const key = MONTH_KEYS[Number(m) - 1];
  return t('common.dateShort', { day: Number(d), month: key ? t(key) : '' });
};
